var map = {
	"./BG.png": "88eb",
	"./KYC-vida.png": "d58a",
	"./api-seeting.png": "534e",
	"./bca.png": "2da3",
	"./bg-login.png": "19b3",
	"./bg-register.png": "063f",
	"./biru.png": "5fd5",
	"./bni.png": "a701",
	"./bri.png": "9f06",
	"./btpn.png": "5f3f",
	"./bulk-icon.png": "20fd",
	"./certif-1.png": "94e3",
	"./certif-2.png": "6798",
	"./certif-3.png": "157b",
	"./cimb.png": "11d9",
	"./company-aditif.png": "e1d1",
	"./company-rucika.png": "cc3c",
	"./company-sosiago.png": "1191",
	"./complete-activate.png": "40c4",
	"./create.png": "bce5",
	"./danamon.png": "65a6",
	"./data_empty.png": "dbaa",
	"./e-sign.png": "cd1c",
	"./emet.png": "2ec4",
	"./empty.png": "f3f6",
	"./example.png": "94e1",
	"./faq.png": "8760",
	"./icon-book.png": "de6d",
	"./icon-contract.png": "c286",
	"./icon-transfer.png": "8873",
	"./img-edit.png": "1ffc",
	"./img-key.png": "208a",
	"./img-logo-black.png": "3c52",
	"./img-otp.png": "a5a3",
	"./img-script.png": "124e",
	"./inventory.png": "ec20",
	"./invoice-icon.png": "4a61",
	"./link_sent.png": "d60e",
	"./loading.png": "cfcf",
	"./logo-white.png": "06f1",
	"./logo.png": "9d64",
	"./mandiri.png": "7517",
	"./materai-icon.png": "4b60",
	"./materil.png": "26e3",
	"./momofin-go.png": "fc80",
	"./no-pict.png": "d985",
	"./orange.png": "0d74",
	"./permata.png": "07f9",
	"./peruri-kyc.png": "ceb6",
	"./peruri-logo-alt.png": "ac97",
	"./peruri-logo.png": "745b",
	"./privy-kyc.png": "9b33",
	"./privy-logo-alt.png": "1097",
	"./privy-logo.png": "8039",
	"./signature.png": "4c2d",
	"./slide-1.png": "ebb1",
	"./slide-2.png": "e392",
	"./slide-3.png": "25a6",
	"./slide-4.png": "4221",
	"./slide-5.png": "05d0",
	"./success.png": "46e6",
	"./vida-logo-alt.png": "07b9",
	"./vida-logo.png": "0393",
	"./xignature-kyc.png": "5398",
	"./xignature-logo-alt.png": "7d71",
	"./xignature-logo.png": "7adc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";